<template>
  <Dashboard :data="profiles">
    <template v-slot:title>
      <h2>{{$t("profiles.title")}}</h2>
    </template>
    <template
      v-slot:buttonRight
      v-if="$store.getters.USERPROFILE['user-profile-administration']"
    >
      <button @click="show.modal = true">
        <i class="fas fa-plus"></i>
        {{$t("button.newProfile")}}
      </button>
      <Add
        v-if="show.modal"
        @close="show.modal = false"
        @get="getProfiles"
      ></Add>
    </template>
    <template v-slot:tab>
      <thead>
        <tr class="trHead">
          <th
            v-for="item in tab"
            :key="item.title"
            class="accentuate"
          >{{item.title}}</th>
          <th></th>
          <th v-if="$store.getters.USERPROFILE['user-profile-administration']"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="data in sortProfile"
          :key="data.title"
        >
          <td>{{data.name}}</td>
          <td>{{data.description}}</td>
          <td>
            <p
              class="chip grey"
              v-if="data['archived']"
            >{{$t("profiles.isArchived")}}</p>
          </td>
          <td
            class="bubbleParent"
            v-if="$store.getters.USERPROFILE['user-profile-administration']"
          >
            <button
              ref="bubble"
              class="outline"
              @click="bubbleClick(data.id)"
            >
              <img
                ref="bubble"
                class="pastille"
                src="@/assets/images/pastille.png"
                alt="pastille"
              >
            </button>
            <div
              class="bubble"
              v-if="bubbleAction(data.id)"
            >
              <a @click="prepareModify(data)">{{$t('profiles.modify')}}</a>
              <a
                v-if="!data['archived']"
                @click="archive(data)"
                class="redText"
              >{{$t('profiles.archive')}}</a>
              <a
                v-if="data['archived']"
                @click="archive(data)"
              >{{$t('profiles.unarchive')}}</a>

            </div>
          </td>
        </tr>
        <!-- over the page displays --
      ------------------------- -->
        <!-- modify Profile -->
        <ModifyProfile
          v-if="modifyProfileDisplay"
          @close="modifyProfileDisplay = false"
          :profile="currentProfile"
          @profilechanged="getProfiles();modifyProfileDisplay=false"
        ></ModifyProfile>
      </tbody>

    </template>

  </Dashboard>
</template>

<script>
import Profiles from "@/services/Profiles";
import Dashboard from "@/components/layout/Dashboard";
import Add from "@/components/profiles/Add";
import bubble from "@/mixins/bubble";
import ModifyProfile from "@/components/profiles/ModifyProfileInBox";
import compare from "@/mixins/compare";
export default {
  mixins: [bubble, compare],
  components: {
    Dashboard,
    Add,
    ModifyProfile
  },
  data() {
    return {
      modifyProfileDisplay: false,
      currentProfile: {},
      tab: [
        { title: this.$t("profiles.role") },
        { title: this.$t("profiles.description") }
      ],
      sort: {
        order: -1,
        type: "name"
      },
      profiles: [],
      show: {
        modal: false,
        bubble: false
      },
      lastClick: ""
    };
  },
  mounted() {
    this.getProfiles();
  },
  computed: {
    sortProfile: function() {
      const prfl = this.profiles;
      return prfl.sort(this.compare);
    }
  },
  methods: {
    prepareModify(data) {
      this.currentProfile = data;
      this.modifyProfileDisplay = true;
    },
    bubbleClick(id) {
      this.lastClick = id;
      this.show.bubble = !this.show.bubble;
    },
    bubbleAction(id) {
      if (this.show.bubble && this.lastClick == id) {
        return true;
      }
    },
    getProfiles() {
      Profiles.get().then(res => {
        this.profiles = res.data;
      });
    },
    archive(data) {
      data.archived = !data.archived;
      Profiles.partialUpdate(data.id, { archived: data.archived }).then(res => {
        if (res.status == 204) {
          this.getProfiles();
        } else {
          console.log("Error: Impossible to archive");
        }
      });
    }
  }
};
</script>